import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon, IconType } from '@factorialco/f0-react'

interface SectionInfoProps {
  icon: IconType
  title: string
  description?: string
}

const SectionInfo = ({ icon, title, description }: SectionInfoProps) => {
  return (
    <>
      <Box flexDirection="row" alignItems="center" gap="s12">
        <F0Icon icon={icon} size="lg" />
        <Text.Normal weight="semibold" size="400">
          {title}
        </Text.Normal>
      </Box>

      {description && (
        <Text.Normal size="300" color="grey600">
          {description}
        </Text.Normal>
      )}
    </>
  )
}

export default SectionInfo
